import {
  get,
  post
} from "./http"
import {
  ADDRESS
} from './address'
export default{
  // test api
  // 会员中心信息
  getVipMine(params) {
    let url = ADDRESS.address + '/vip-home/new-mine'
    return get(url, params)
  },
  // 获取会员详情信息
  getVipInfo(params) {
    let url = ADDRESS.address2 + '/union-vip/index'
    return get(url, params)
  },
  // ios支付
  getPayIos(params) {
    let url = ADDRESS.address2 + '/vip-pay/union-itune-app-pay'
    return post(url, params)
  },
  // 安卓支付
  getPayAndroid(params) {
    let url = ADDRESS.address2 + '/vip-pay/union-vip-app-pay'
    return post(url, params)
  },
  // 支付成功回调
  getVipPaySuccseInfo(params) {
    let url = ADDRESS.address2 + '/union-vip/get-union-paid-info'
    return get(url, params)
  },
  // 联合会员购买记录
  getVipPayRecordInfo(params) {
    let url = ADDRESS.address2 + '/union-vip/vip-history'
    return get(url, params)
  },
  // 联合会员购买记录
  getCCtvVipRights() {
    let url = 'https://api-vip.sports.cctv.com/vip/service?statistics=android_app'
    return get(url)
  },
}